import React, {ReactNode, ReactElement} from 'react';
import {cx} from '@emotion/css';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';
import Paragraph from '../Text/Paragraph/Paragraph';

import styles from './CardLink.styles';

export interface CardLinkProps {
  href: string;
  icon?: ReactNode;
  label: ReactNode;
  description?: ReactNode;
  className?: string;
  compact?: boolean;
  blank?: boolean;
  forceAnchorLink?: boolean;
}

function CardLink({
  href,
  icon,
  label,
  description,
  compact,
  className,
  blank,
  forceAnchorLink,
}: CardLinkProps): ReactElement {
  return (
    <DynamicLink
      href={href}
      className={cx(styles.container, 'unstyledLink', className)}
      forceAnchorLink={forceAnchorLink}
      blank={blank}
    >
      {icon && <div className={cx(styles.icon(compact))}>{icon}</div>}
      <div className={cx(styles.text)}>
        <Paragraph className={cx(styles.label)}>{label}</Paragraph>
        {!compact && description && <Paragraph className={cx(styles.description)}>{description}</Paragraph>}
      </div>
    </DynamicLink>
  );
}

export default CardLink;
